import { render, staticRenderFns } from "./DetalhesContaConsumo.vue?vue&type=template&id=3862f5da&"
import script from "./DetalhesContaConsumo.vue?vue&type=script&lang=js&"
export * from "./DetalhesContaConsumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports